export type { Vehicle, VehicleDraft, VehicleListItem, VehicleSearchQuery } from './domain/types';
export { vehicleDisplay, vehiclePlateLabel } from './domain/types';
export { validateVehicleDraft, type VehicleValidationResult } from './domain/vehicleValidation';
export {
  listVehicles,
  getVehicle,
  upsertVehicle,
  deactivateVehicle,
} from './infra/vehiclesRepo';
export { VehiclesScreen } from './screens/VehiclesScreen';
export { VehicleFormScreen } from './screens/VehicleFormScreen';
export { ServiceRemindersScreen } from './screens/ServiceRemindersScreen';
export { VehicleHistoryScreen } from './screens/VehicleHistoryScreen';
export {
  listVehicleServiceReminders,
  listDueServiceReminders,
  upsertServiceReminder,
  completeServiceReminder,
  snoozeServiceReminder,
  deleteServiceReminder,
  type ServiceReminder,
  type ServiceReminderDraft,
  type DueServiceReminder,
} from './infra/serviceRemindersRepo';
export {
  listVehicleServiceHistory,
  getVehicleServiceSummary,
  type VehicleServiceHistoryEntry,
  type VehicleServiceSummary,
} from './infra/vehicleServiceHistoryRepo';
